document.addEventListener('DOMContentLoaded', () => {
  const searchInput = document.getElementById('sku-search')
  const clearButton = document.getElementById('clear-search')

  const defaultGrid = document.getElementById('default-ingredients-grid')
  const ajaxGrid = document.getElementById('ajax-ingredients-grid')

  const productBanner = document.getElementById('selected-product-banner')
  const productImage = document.getElementById('selected-product-image')
  const productTitle = document.getElementById('selected-product-title')
  const productDescription = document.getElementById('selected-product-description')
  const productMetaContainer = document.getElementById('selected-product-meta')
  const productLastUpdated = document.getElementById('selected-product-last-updated')
  const productAllergens = document.getElementById('selected-product-allergens')
  const noResultsBanner = document.getElementById('no-results-banner')

  let currentAbortController = null

  function filterIngredients(sku) {
    sku = sku.trim().toUpperCase()

    // Cancel any pending request
    if (currentAbortController) {
      currentAbortController.abort()
    }

    // Toggle clear button
    if (sku.length > 0) {
      clearButton.classList.remove('hidden')
    } else {
      clearButton.classList.add('hidden')
    }

    if (sku === '') {
      // Reset view to default grid with show_on_landing logic
      ajaxGrid.classList.add('hidden')
      ajaxGrid.innerHTML = ''
      defaultGrid.classList.remove('hidden')

      const defaultCards = defaultGrid.querySelectorAll('.ingredient-card')
      defaultCards.forEach(card => {
        const showOnLanding = card.getAttribute('data-show-on-landing') === 'true'
        if (showOnLanding) {
          card.style.display = 'flex'
          void card.offsetWidth // force reflow
          card.style.opacity = '1'
          card.style.transform = 'scale(1)'
        } else {
          card.style.opacity = '0'
          card.style.transform = 'scale(0.95)'
          setTimeout(() => {
            if (card.style.opacity === '0') {
              card.style.display = 'none'
            }
          }, 300)
        }
      })
      hideBanner()
      noResultsBanner.classList.add('hidden')
      return
    }

    // If searching, we hit our AJAX endpoint
    // First, let's visually prepare for search
    currentAbortController = new AbortController()

    const searchUrl =
      (window.ingredientSettings && window.ingredientSettings.searchUrl) || '/search'

    fetch(`${searchUrl}?view=ingredients-ajax&q=${encodeURIComponent(sku)}`, {
      signal: currentAbortController.signal
    })
      .then(response => response.json())
      .then(data => {
        if (data.found) {
          // Hide default grid
          defaultGrid.classList.add('hidden')
          // Inject new HTML
          ajaxGrid.innerHTML = data.html
          ajaxGrid.classList.remove('hidden')

          // Re-init accordions for new HTML
          initAccordions(ajaxGrid)

          // Show banner
          showBanner(data.product)
          noResultsBanner.classList.add('hidden')
        } else {
          // No results
          defaultGrid.classList.add('hidden')
          ajaxGrid.classList.add('hidden')
          hideBanner()
          noResultsBanner.classList.remove('hidden')
        }
      })
      .catch(error => {
        if (error.name === 'AbortError') return
        console.error('Error fetching ingredients:', error)
      })
  }

  function showBanner(product) {
    productTitle.textContent = product.title

    if (product.description && product.description.trim() !== '') {
      productDescription.textContent = product.description
      productDescription.classList.remove('hidden')
    } else {
      productDescription.classList.add('hidden')
    }

    if (product.image && product.image.trim() !== '') {
      productImage.src = product.image
      productImage.classList.remove('hidden')
      productImage.parentElement.classList.remove('bg-gray/5')
      productImage.parentElement.classList.add('bg-white')
    } else {
      productImage.classList.add('hidden')
      productImage.parentElement.classList.add('bg-gray/5')
      productImage.parentElement.classList.remove('bg-white')
    }

    let hasMeta = false

    if (product.lastUpdated && product.lastUpdated.trim() !== '') {
      productLastUpdated.querySelector('.value').textContent = product.lastUpdated
      productLastUpdated.classList.remove('hidden')
      hasMeta = true
    } else {
      productLastUpdated.classList.add('hidden')
    }

    if (product.allergens && product.allergens.trim() !== '') {
      productAllergens.querySelector('.value').textContent = product.allergens
      productAllergens.classList.remove('hidden')
      hasMeta = true
    } else {
      productAllergens.classList.add('hidden')
    }

    if (hasMeta) {
      productMetaContainer.classList.remove('hidden')
      productMetaContainer.classList.add('flex')
    } else {
      productMetaContainer.classList.add('hidden')
      productMetaContainer.classList.remove('flex')
    }

    productBanner.classList.remove('hidden')
    productBanner.classList.add('flex')
    // Force reflow
    void productBanner.offsetWidth
    productBanner.classList.add('show-banner')
    productBanner.classList.remove('opacity-0', 'translate-y-4')
  }

  function hideBanner() {
    productBanner.classList.remove('show-banner')
    productBanner.classList.add('opacity-0', 'translate-y-4')
    setTimeout(() => {
      if (productBanner.classList.contains('opacity-0')) {
        productBanner.classList.add('hidden')
        productBanner.classList.remove('flex')
      }
    }, 300)
  }

  // Debounce function
  function debounce(func, wait) {
    let timeout
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout)
        func(...args)
      }
      clearTimeout(timeout)
      timeout = setTimeout(later, wait)
    }
  }

  const debouncedFilter = debounce(val => filterIngredients(val), 300)

  searchInput.addEventListener('input', e => {
    // Only search if length is at least 3, to avoid too many requests on short SKUs
    // Or if it's empty, we trigger reset immediately
    const val = e.target.value.trim()
    if (val.length === 0 || val.length >= 3) {
      debouncedFilter(val)
    }
  })

  clearButton.addEventListener('click', () => {
    searchInput.value = ''
    filterIngredients('')
    searchInput.focus()
  })

  // Handle accordion custom animation via details
  function initAccordions(container) {
    const accordions = container.querySelectorAll('.ingredient-details')
    accordions.forEach(acc => {
      // remove old listener if any to avoid duplicates, although we usually inject fresh HTML
      acc.addEventListener('click', e => {
        if (e.target.closest('summary')) {
          e.preventDefault()

          if (acc.hasAttribute('open')) {
            acc.removeAttribute('open')
          } else {
            // Close others
            accordions.forEach(otherAcc => {
              if (otherAcc !== acc && otherAcc.hasAttribute('open')) {
                otherAcc.removeAttribute('open')
              }
            })
            acc.setAttribute('open', '')
          }
        }
      })
    })
  }

  // Init initial accordions
  initAccordions(document)

  // SKU Finder Logic
  const toggleSkuFinderBtn = document.getElementById('toggle-sku-finder')
  const closeSkuFinderBtn = document.getElementById('close-sku-finder')
  const skuFinderContainer = document.getElementById('sku-finder-container')
  const skuFinderGrid = document.getElementById('sku-finder-grid')
  const skuFinderLoading = document.getElementById('sku-finder-loading')
  let skuFinderLoaded = false

  function openSkuFinder() {
    skuFinderContainer.classList.remove('hidden')
    defaultGrid.classList.add('hidden')
    ajaxGrid.classList.add('hidden')
    productBanner.classList.add('hidden')
    noResultsBanner.classList.add('hidden')

    if (!skuFinderLoaded) {
      skuFinderLoading.classList.remove('hidden')
      loadAllSkus()
    }
  }

  function closeSkuFinder() {
    skuFinderContainer.classList.add('hidden')
    // Re-evaluate search input to restore the correct grids and banners
    filterIngredients(searchInput.value)
  }

  if (toggleSkuFinderBtn) {
    toggleSkuFinderBtn.addEventListener('click', openSkuFinder)
  }
  if (closeSkuFinderBtn) {
    closeSkuFinderBtn.addEventListener('click', closeSkuFinder)
  }

  async function loadAllSkus() {
    try {
      const searchUrl =
        (window.ingredientSettings && window.ingredientSettings.searchUrl) || '/search'
      // Fetch first page
      const firstPageRes = await fetch(`${searchUrl}?view=sku-list-ajax&page=1`)
      const firstPageData = await firstPageRes.json()

      let allItems = [...firstPageData.items]
      const totalPages = firstPageData.total_pages

      // If more pages, fetch them in parallel
      if (totalPages > 1) {
        const promises = []
        for (let i = 2; i <= totalPages; i++) {
          promises.push(fetch(`${searchUrl}?view=sku-list-ajax&page=${i}`).then(res => res.json()))
        }
        const remainingPages = await Promise.all(promises)
        remainingPages.forEach(pageData => {
          allItems = allItems.concat(pageData.items)
        })
      }

      // Sort items alphabetically by title
      allItems.sort((a, b) => a.title.localeCompare(b.title))

      // Generate HTML
      let html = ''
      allItems.forEach(item => {
        const imgSrc = item.image ? item.image : ''

        html += `
          <button type="button" class="sku-finder-card flex flex-col items-center p-4 border border-gray/10 rounded-xl hover:border-breeze-blue hover:shadow-sm transition-all text-center group bg-white" data-sku="${item.sku}">
            <div class="h-20 w-20 flex items-center justify-center mb-3">
              ${imgSrc ? `<img src="${imgSrc}" alt="${item.title}" class="max-w-full max-h-full object-contain group-hover:scale-105 transition-transform">` : `<div class="w-10 h-10 bg-gray/10 rounded-full flex items-center justify-center"><span class="text-xs text-gray/50">No Image</span></div>`}
            </div>
            <span class="text-sm font-semibold text-dark-navy-black leading-tight">${item.title}</span>
            <span class="text-xs text-dark-blue-gray mt-1 font-mono">${item.sku}</span>
          </button>
        `
      })

      skuFinderGrid.innerHTML = html

      // Add click listeners to cards
      const cards = skuFinderGrid.querySelectorAll('.sku-finder-card')
      cards.forEach(card => {
        card.addEventListener('click', () => {
          const sku = card.getAttribute('data-sku')
          searchInput.value = sku
          // closeSkuFinder will automatically trigger filterIngredients with the new input value
          closeSkuFinder()
          // Scroll up to the results area smoothly
          productBanner.scrollIntoView({ behavior: 'smooth', block: 'center' })
        })
      })

      skuFinderLoaded = true
      skuFinderLoading.classList.add('hidden')
    } catch (error) {
      console.error('Error loading SKUs:', error)
      skuFinderLoading.classList.add('hidden')
      skuFinderGrid.innerHTML =
        '<p class="text-center text-red-500 col-span-full">Failed to load products. Please try again later.</p>'
    }
  }
})
